import { addDoc, collection, doc, getDocs, orderBy, query, serverTimestamp, updateDoc, where } from "firebase/firestore"

/**
 * @typedef {Object} Conversation
 * @property {string} id
 * @property {string[]} participants
 * @property {string} dernierMessage
 */
export default class FirebaseConversation {
  constructor(baseDeDonnees) {
    this.baseDeDonnees = baseDeDonnees
  }

  get bdd() {
    return this.baseDeDonnees.bdd
  }

  recupererIdUtilisateurCourant() {
    return this.baseDeDonnees.recupererIdUtilisateurCourant()
  }

  async journaliserErreurEtRelancer(error, contexte) {
    return this.baseDeDonnees.journaliserErreurEtRelancer(error, contexte)
  }

  async recupererToutesLesConversations() {
    try {
      const docRef = collection(this.bdd, "conversations")
      const snapshot = await getDocs(docRef)
      const conversations = []

      snapshot.forEach((docSnapshot) => {
        conversations.push({ id: docSnapshot.id, ...docSnapshot.data() })
      })
      return conversations
    } catch (error) {
      await this.journaliserErreurEtRelancer(error, "recupererToutesLesConversations")
    }
  }

  async recupererLaReferenceDuneConversation(idConversation) {
    return doc(this.bdd, "conversations", idConversation)
  }

  async recupererToutesLesConversationsDuMembreConnecte() {
    try {
      const idMembreConnecte = this.recupererIdUtilisateurCourant()
      const q = query(collection(this.bdd, "conversations"), where("participants", "array-contains", idMembreConnecte))
      const snapshot = await getDocs(q)
      const conversations = []

      snapshot.forEach((docSnapshot) => {
        const data = docSnapshot.data()
        if (data.participants.includes(idMembreConnecte)) {
          conversations.push({ id: docSnapshot.id, ...docSnapshot.data() })
        }
      })
      return conversations
    } catch (error) {
      await this.journaliserErreurEtRelancer(error, "recupererToutesLesConversationsDuMembreConnecte")
    }
  }

  async recupererTousLesMessagesDuneConversation(idConversation) {
    try {
      const docRef = query(collection(this.bdd, "conversations", idConversation, "messages"), orderBy("creerA"))
      const snapshot = await getDocs(docRef)
      const messages = []

      snapshot.forEach((docSnapshot) => {
        messages.push({ id: docSnapshot.id, ...docSnapshot.data() })
      })
      return messages
    } catch (error) {
      await this.journaliserErreurEtRelancer(error, "recupererTousLesMessagesDuneConversation")
    }
  }

  async creerUneConversation(participant) {
    try {
      const idMembreConnecte = this.recupererIdUtilisateurCourant()
      const conversation = {
        participants: [idMembreConnecte, participant],
        dernierMessage: "",
        messages: [],
      }
      const docRef = await addDoc(collection(this.bdd, "conversations"), conversation)

      return docRef.id
    } catch (error) {
      await this.journaliserErreurEtRelancer(error, "creerUneConversation")
    }
  }

  async ajouterUnMessageDansUneConversation(idConversation, message) {
    try {
      const docRefConversation = collection(this.bdd, "conversations", idConversation, "messages")

      await addDoc(docRefConversation, { ...message, creerA: serverTimestamp() })

      const docRefConversationPrincipal = doc(this.bdd, "conversations", idConversation)

      return updateDoc(docRefConversationPrincipal, {
        dernierMessage: message.contenu,
        dateDernierMessage: serverTimestamp(),
      })
    } catch (error) {
      await this.journaliserErreurEtRelancer(error, "ajouterUnMessageDansUneConversation")
    }
  }
}
